<kendo-svg-icon [size]="$size() ?? 'default'" [icon]="$svgIcon()" />
